import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ErrorHandler {

    parseResponse(response: any): string {
        let errMsg = 'Internal Server Error';
        if (response['json'] && response.json() && response.json().hasOwnProperty('errorMessage')) {
            errMsg = response.json().errorMessage;
        } else if (response['message']) {
            errMsg = response.message;
        }
        return errMsg;
    }

    throwError(response: any, formatter?: (msg: string) => string): Observable<any> {
        let errMsg = this.parseResponse(response);
        console.error('Backend error: ' + errMsg);
        if (formatter) {
            errMsg = formatter(errMsg);
        }
        return Observable.throw(errMsg);
    }

}



// WEBPACK FOOTER //
// ./src/app/restapi/error-handler.ts